import React from 'react';

import { createContext } from '@lyearn/core/utils/context';
import useAsyncListActions from '@/hooks/useList/useAsyncListActions';

const [Provider, useAddTaskModalContext] = createContext<{
  state: ReturnType<typeof useAsyncListActions>['state'];
  methods: ReturnType<typeof useAsyncListActions>['methods'];
}>('AddTasksModal');

interface Props {
  children: React.ReactNode;
}

function AddTaskModalProvider(props: Props) {
  const { state, methods } = useAsyncListActions();

  return (
    <Provider methods={methods} state={state}>
      {props.children}
    </Provider>
  );
}

export { useAddTaskModalContext };
export default React.memo(AddTaskModalProvider);
